import React from "react";
import { motion } from "framer-motion";

/**
 * Artistic section divider — a luminous orb rising over nested gold contour
 * ridges (Andro-Pang-inspired celestial topography), with an optional label.
 */
export const ArtDivider = ({ label, className = "", testId = "art-divider" }) => {
  const ridges = [0, 1, 2, 3, 4];
  return (
    <div
      data-testid={testId}
      className={`relative flex flex-col items-center py-10 ${className}`}
      aria-hidden={label ? undefined : "true"}
    >
      <svg
        viewBox="0 0 600 120"
        className="h-[120px] w-full max-w-2xl"
        fill="none"
        preserveAspectRatio="xMidYMid meet"
      >
        <defs>
          <radialGradient id="ad-orb" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#FBEEC6" stopOpacity="0.95" />
            <stop offset="40%" stopColor="#E7CC90" stopOpacity="0.5" />
            <stop offset="100%" stopColor="#C5A059" stopOpacity="0" />
          </radialGradient>
          <linearGradient id="ad-line" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#C5A059" stopOpacity="0" />
            <stop offset="50%" stopColor="#C5A059" stopOpacity="0.9" />
            <stop offset="100%" stopColor="#C5A059" stopOpacity="0" />
          </linearGradient>
        </defs>
        <motion.circle
          cx="300"
          cy="52"
          r="60"
          fill="url(#ad-orb)"
          initial={{ opacity: 0, scale: 0.7 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
        />
        <circle cx="300" cy="52" r="9" fill="#F3E1AE" opacity="0.95" />
        <g stroke="url(#ad-line)" fill="none">
          {ridges.map((i) => {
            const y = 60 + i * 12;
            const peak = 26 - i * 4;
            const d = `M 40 ${y} C 160 ${y - peak}, 240 ${y - peak}, 300 ${y - peak} S 440 ${y}, 560 ${y}`;
            return (
              <motion.path
                key={i}
                d={d}
                strokeWidth={i === 0 ? 1.3 : 0.8}
                initial={{ pathLength: 0, opacity: 0 }}
                whileInView={{ pathLength: 1, opacity: 0.9 - i * 0.13 }}
                viewport={{ once: true }}
                transition={{ duration: 1.4, delay: 0.1 + i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              />
            );
          })}
        </g>
      </svg>
      {label && (
        <span className="kicker -mt-3 text-gold-deep">{label}</span>
      )}
    </div>
  );
};
